const activeFadeRaf = new WeakMap();

const clearFadeRaf = (media) => {
  const rafId = activeFadeRaf.get(media);
  if (rafId) {
    cancelAnimationFrame(rafId);
    activeFadeRaf.delete(media);
  }
};

const runVolumeFade = (media, from, to, durationMs = 140) =>
  new Promise((resolve) => {
    if (!media) {
      resolve();
      return;
    }
    clearFadeRaf(media);
    const start = performance.now();
    const delta = to - from;

    const step = (now) => {
      const progress = Math.min((now - start) / durationMs, 1);
      media.volume = Math.min(Math.max(from + delta * progress, 0), 1);
      if (progress >= 1) {
        activeFadeRaf.delete(media);
        resolve();
        return;
      }
      const rafId = requestAnimationFrame(step);
      activeFadeRaf.set(media, rafId);
    };

    media.volume = Math.min(Math.max(from, 0), 1);
    const rafId = requestAnimationFrame(step);
    activeFadeRaf.set(media, rafId);
  });

export const fadeInPlay = async (media, durationMs = 140, targetVolume = 1) => {
  if (!media) return false;
  const wantedVolume = Math.min(Math.max(targetVolume, 0), 1);
  clearFadeRaf(media);
  media.volume = 0.001;
  try {
    await media.play();
    await runVolumeFade(media, media.volume, wantedVolume, durationMs);
    return true;
  } catch {
    return false;
  }
};

export const fadeOutPause = async (media, durationMs = 140, resumeVolume = 1) => {
  if (!media) return;
  const startVolume = typeof media.volume === 'number' ? media.volume : 1;
  await runVolumeFade(media, startVolume, 0.001, durationMs);
  media.pause();
  media.volume = Math.min(Math.max(resumeVolume, 0), 1);
};

